module.exports = __webpack_public_path__ + "img/T2A_rc_17.1200604d.png";